import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledListIconButton = styled(IconButton)`
    background-color: ${rgba(colorsPalettes.carbon["0"], 0.2)};
    min-width: 25px;

    &.primary {
        .SWReactIcons svg path {
            fill: ${colorsPalettes.carbon[0]};
        }

        &:hover {
            background-color: ${rgba(colorsPalettes.carbon[25], 0.4)} !important;

            .SWReactIcons svg path {
                fill: ${colorsPalettes.carbon[0]};
                opacity: 1;
            }
        }
    }

    &.disabled {
        pointer-events: none;
        cursor: not-allowed;

        .SWReactIcons svg path {
            fill: ${colorsPalettes.carbon[200]};
        }

        & > div {
            color: ${colorsPalettes.carbon[200]};
        }
    }
`;
